module.exports = __webpack_public_path__ + "static/media/after-dice.99962bc8.png";